import { useEffect, useRef } from 'react';
import { supabase } from '../../lib/supabaseClient';

/**
 * «Resumen»: el resumen gerencial dentro del panel (0396). Es la pantalla con la que entra dirección (Francisco) y
 * el admin la tiene en el menú.
 *
 * La página es LA MISMA que se publica aparte (`entregables/resumen-gerencial/public`, servida por la app en
 * `/resumen/`): así no hay dos resúmenes que se separen con el tiempo. Va en un marco y no reescrita en React por eso.
 * Sus datos no los pide al Worker —que tiene su propio usuario y clave— sino al panel, por mensajes, y el panel los
 * lee con la sesión de quien entró (`resumen_gerencial_panel`, solo admin y dirección).
 *
 * Solo se contesta al marco propio y del mismo origen: cualquier otra ventana que mande «resumen:pedir» se ignora.
 */
export default function ResumenGerencial() {
  const marco = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    async function atender(e: MessageEvent) {
      const ventana = marco.current?.contentWindow;
      if (!ventana || e.source !== ventana || e.origin !== window.location.origin) return;
      const pedido = e.data as { tipo?: string; id?: number; mes?: string } | null;
      if (pedido?.tipo !== 'resumen:pedir') return;
      const mes = /^\d{4}-\d{2}$/.test(pedido.mes ?? '') ? `${pedido.mes}-01` : null;
      const { data, error } = await supabase.rpc('resumen_gerencial_panel', { p_mes: mes });
      ventana.postMessage(
        { tipo: 'resumen:datos', id: pedido.id, datos: error ? null : data, error: error?.message ?? null },
        window.location.origin,
      );
    }
    window.addEventListener('message', atender);
    return () => window.removeEventListener('message', atender);
  }, []);

  return (
    <iframe
      ref={marco}
      // `/resumen/` y no `/resumen/index.html`: Cloudflare Pages redirige este último (308) al primero.
      src="/resumen/?embebido=1"
      title="Resumen gerencial"
      className="block h-[calc(100dvh-6rem)] w-full rounded border-0 lg:h-[calc(100vh-3rem)]"
    />
  );
}
